<template>
  <div :class="state">
    <div class="container">
      <!-- 左侧logo -->
      <a href="http://filseclab.com/">
        <img height="60px" src="../assets/logo.png" alt="Logo" />
      </a>
      <!-- 右侧导航 -->
      <el-menu
        v-if="state === 'pc'"
        :default-active="activeIndex"
        mode="horizontal"
        text-color="#464646"
        active-text-color="#2a81b7"
        router
      >
        <el-menu-item index="home">首页</el-menu-item>
        <el-menu-item index="product">产品</el-menu-item>
        <el-menu-item index="download">下载</el-menu-item>
        <el-menu-item index="support">支持</el-menu-item>
        <el-menu-item index="forum">论坛</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
// import Logo from '../assets/logo.png'
export default {
  setup() {
    const state = computed(() => useStore().state.client)
    const activeIndex = ref('home')
    const route = useRoute()
    // const LogoImg = Logo
    watch(
      () => route.path,
      () => {
        activeIndex.value !== route.path.substring(1)
          ? (activeIndex.value = route.path.substring(1))
          : null
      }
    )
    return {
      state,
      activeIndex,
    }
  },
}
</script>

<style lang="scss">
.pc {
  .container {
    width: 12rem;
    height: 1rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    a {
      font-size: 0;
    }
    .el-menu {
      border: none;
      .el-menu-item {
        font-size: 0.18rem;
      }
      .is-active {
        border-bottom-color: #2a81b7 !important;
        color: #2a81b7 !important;
      }
    }
  }
}
.mobile {
  .container {
    font-size: 0;
    box-sizing: border-box;
    padding: 0.2rem 0.1rem;
    a {
      img {
        width: 2.5rem;
      }
    }
  }
}
</style>
